import { render, staticRenderFns } from "./registroPagos.vue?vue&type=template&id=52f32592&scoped=true"
import script from "./registroPagos.vue?vue&type=script&lang=js"
export * from "./registroPagos.vue?vue&type=script&lang=js"
import style0 from "./registroPagos.vue?vue&type=style&index=0&id=52f32592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f32592",
  null
  
)

export default component.exports